@if (viewModel$ | async; as vm) {
  @if (!vm.error) {
    <bp-tile [title]="'cash_plus' | translate" color="default" [padding]="false" class="card">
      <!--button class="button-weight btn-manage" tile-actions [tabIndex]="0" (click)="showEarnedModal()">
      {{ "dashboard_watchlist_manage" | translate }}
    </button-->
    <div class="cashplus-container">
      <div class="item">
        <span class="grey-label">{{ "cash_plus_cash_balance" | translate }}</span>
        <span hidePortfolioValue [isHideActive]="vm.isPortfolioHidden">{{
          vm.cashBalance
          | fiat_precision_symbol
          : {
          id: vm.defaultFiatId,
          symbol: true
        }
      }}</span>
    </div>
    <div class="item">
      <span class="grey-label">{{ "cash_plus_cash_plus_balance" | translate }}</span>
      <span hidePortfolioValue [isHideActive]="vm.isPortfolioHidden">{{
        vm.cashPlusBalance
        | fiat_precision_symbol
        : {
        id: vm.defaultFiatId,
        symbol: true
      }
    }}</span>
  </div>
  <div class="item total-rewards">
    <span class="">{{ "cash_plus_total_reward_this_month" | translate }}</span>
    <span hidePortfolioValue [isHideActive]="vm.isPortfolioHidden">{{
      vm.totalRewards
      | fiat_precision_symbol
      : {
      id: vm.defaultFiatId,
      symbol: true
    }
  }}</span>
</div>
</div>
<hr />
<div class="cashplus-btn-container">
  <button class="btn btn-primary" (click)="handleManageClick()">
    {{ "cash_plus_go_to_wallet" | translate }}
  </button>
</div>
</bp-tile>
} @else {
  <bp-tile [title]="'cash_plus' | translate" color="default" [padding]="false" class="card">
    <div class="cashplus-container-error">
      <img
        class="error-icon"
        src="/assets/images/CashPlus_Widget_Error.svg"
        alt="{{ 'cash_plus_try_again_alt' | translate }}" />
      <div class="error-message">
        {{ "cash_plus_try_again_error_message" | translate }}
      </div>
      <div class="button-section">
        @if ((isLoading$ | async) === false) {
          <a class="try-again-button" (click)="reFetchAPI()">{{
            "cash_plus_try_again_button" | translate
          }}</a>
        } @else {
          <loading-spinner class="no-padding"></loading-spinner>
        }
      </div>
    </div>
  </bp-tile>
}
}
